import { render, staticRenderFns } from "./DocumentListTenn.vue?vue&type=template&id=49dade35&scoped=true&"
import script from "./DocumentListTenn.vue?vue&type=script&lang=js&"
export * from "./DocumentListTenn.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListTenn.vue?vue&type=style&index=0&id=49dade35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dade35",
  null
  
)

export default component.exports